import * as React from "react";
const SuccessIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="#00bb80"
      fillRule="evenodd"
      d="M24 5c10.493 0 19 8.507 19 19s-8.507 19-19 19S5 34.493 5 24 13.507 5 24 5Z"
      clipRule="evenodd"
      data-filled="true"
    />
    <path
      fill="#00bb80"
      fillRule="evenodd"
      d="M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16Zm0 3c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19Z"
      clipRule="evenodd"
      data-filled="false"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M33.538 20.002 21.104 32.436l-6.75-6.75 2.119-2.123 4.631 4.63 10.302-10.3 2.132 2.11Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SuccessIcon;
